import { IVolTab, VolSkewReferenceLine } from '../types/impliedVol';
import { ALPHA_UPSELL_ITEMS } from './shared';

export const IVOL_UPSELL = {
  title: 'Unlock Full Implied Volatility Access',
  subtitle: "With a SpotGamma Alpha subscription, you'll get:",
  items: ALPHA_UPSELL_ITEMS,
};

export const IVOL_APPCUES = {
  [IVolTab.FixedStrikeMatrix]: '1506c18a-ddab-4b9b-9b8a-4d3057653fb1',
  [IVolTab.TermStructure]: '0df4712b-7bed-4656-88f3-1fa779d3a156',
  [IVolTab.VolSkew]: 'dd93bfb8-8298-451c-bdce-3afec2302957',
  [IVolTab.Vix]: 'be26a1f9-5a4e-4c1c-aff5-a445b3086351',
};

export const IVOL_SKEW_BASE_LINE_LABELS_MAP: Record<
  VolSkewReferenceLine,
  string
> = {
  [VolSkewReferenceLine.CurrentIV]: 'Current IV',
  [VolSkewReferenceLine.MinIV]: 'Min IV',
  [VolSkewReferenceLine.MaxIV]: 'Max IV',
  [VolSkewReferenceLine.MedianIV]: 'Median IV',
  [VolSkewReferenceLine.AvgIV]: 'Avg IV',
  [VolSkewReferenceLine.P10_IV]: 'P10 IV',
  [VolSkewReferenceLine.P25_IV]: 'P25 IV',
  [VolSkewReferenceLine.P75_IV]: 'P75 IV',
  [VolSkewReferenceLine.P90_IV]: 'P90 IV',
};
